import React from 'react'
import SbEditable from 'storyblok-react'
import { ContactCard } from '@/components/ui/contact-card'
import RichText from '@/utils/RichText'

export type Card = {
  heading: string
  content: string
  image?: string
}

export interface ContactBlockProps {
  blok: Card
}

export const ContactBlock = ({ blok }: ContactBlockProps) => {
  return (
    <div>
      {/** @ts-ignore: Storyblok typing issue with children **/}
      <SbEditable content={blok}>
        <ContactCard img={blok.image}>
          <span className="prose max-w-xs text-lg font-semibold text-darkblue">
            <RichText>{blok.heading}</RichText>
          </span>
          <span className="prose max-w-xs text-xs font-semibold text-darkblue break-words overflow-hidden text-ellipsis">
            <RichText>{blok.content}</RichText>
          </span>
        </ContactCard>
      </SbEditable>
    </div>
  )
}

ContactBlock.displayName = 'ContactBlock'
